import {
    AdminIdentityEntity,
    ALL_DEMAND_SCOPES,
    ResonanceIdentityType,
    DemandHqIdentityApiCreateInput,
    DemandHqIdentityApiUpdateInput,
    DemandRole,
} from "@buildresonance/resonance-lib-entities";
import { string, object, ObjectSchema, array } from "yup";

import {
    appIdSchema,
    resonanceIdentityIdSchema,
} from "../adminIdentity/adminIdentityIds";
import { requiredOnlyWhenExistsObjectTransformer } from "../objectHelpers";
import { transformBlankStringToNull } from "../stringHelpers";

import { demandHqIdSchema } from "./demandIds";

export const demandHqIdentityApiCreateInputSchema: ObjectSchema<DemandHqIdentityApiCreateInput> =
    object({
        identityId: resonanceIdentityIdSchema.required(),
        identityType: string<ResonanceIdentityType>()
            .transform(transformBlankStringToNull)
            .required()
            .oneOf([AdminIdentityEntity.AppClient, AdminIdentityEntity.User]),
        identityParentEntityId: appIdSchema.nullable(),
        permissions: object({
            roles: array()
                .of(
                    string()
                        .transform(transformBlankStringToNull)
                        .required()
                        .oneOf(Object.values(DemandRole)),
                )
                .required(),
            scopes: array()
                .of(
                    string()
                        .transform(transformBlankStringToNull)
                        .required()
                        .oneOf(ALL_DEMAND_SCOPES),
                )
                .required(),
        }).required(),
        demandHqId: demandHqIdSchema.required(),
    }).noUnknown();

export const demandHqIdentityApiUpdateInputSchema: ObjectSchema<DemandHqIdentityApiUpdateInput> =
    object({
        identityId: resonanceIdentityIdSchema.required(),
        identityParentEntityId: appIdSchema.nullable(),
        permissions: object({
            roles: array()
                .of(
                    string()
                        .transform(transformBlankStringToNull)
                        .required()
                        .oneOf(Object.values(DemandRole)),
                )
                .required(),
            scopes: array()
                .of(
                    string()
                        .transform(transformBlankStringToNull)
                        .required()
                        .oneOf(ALL_DEMAND_SCOPES),
                )
                .required(),
        })
            .transform(requiredOnlyWhenExistsObjectTransformer)
            .default(undefined),
        demandHqId: demandHqIdSchema.required(),
    }).noUnknown();
